import * as React from 'react';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { Replay } from '@sentry/browser';
import { excludeGraphQLFetch } from 'apollo-link-sentry';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

export function initO11y() {
  Sentry.init({
    beforeBreadcrumb: excludeGraphQLFetch,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
        traceFetch: false,
      }),
      new Replay(),
    ],
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
  });
}

export default Sentry;
